import { InputAdornmentButton } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useAppDispatch, useModalState } from 'shared/hooks';
import { LocationSwitcherModalContainer } from '../ModalContainer';
import { loadLocationSwitcherData } from 'shared/thunks/geo/locationSwitcher';
import { trackOpenGeoModal } from './tracking';

export const LocationSwitcherPopupButtonContainer = () => {
  const dispatch = useAppDispatch();

  const { opened, onClose, onOpen } = useModalState();

  const handleLocationSwitcherButtonClick = useCallback(() => {
    onOpen();
    dispatch(loadLocationSwitcherData());
    trackOpenGeoModal();
  }, [dispatch, onOpen]);

  return (
    <>
      <InputAdornmentButton type="button" onClick={handleLocationSwitcherButtonClick}>
        Регион
      </InputAdornmentButton>
      {opened && <LocationSwitcherModalContainer onModalClose={onClose} />}
    </>
  );
};
